import { REQUEST_TYPES } from '../requestTypes';
import { defaultChartRequest, defaultTableRequest } from '../requestHelper';
import { ENTITY_NAMES } from '../entityNames';
import { ENDPOINTS } from '../../../config/config';
import { DASHBOARD_API_URLS } from '../../constants';
import { type RequestHandlerFactory } from '../../types';

const url = DASHBOARD_API_URLS.V2.CALL_STATS;

export const callStatsRequests: Record<string, RequestHandlerFactory> = {
    [REQUEST_TYPES.GET_OVERVIEW_SPEECH_RATIO]: defaultChartRequest(
        url,
        ENTITY_NAMES.OVERVIEW_SPEECH_RATIO,
        ENDPOINTS.VF_DASHBOARD_URL
    ),
    [REQUEST_TYPES.GET_OVERVIEW_AGENCY_SPEECH_RATIO]: defaultChartRequest(
        url,
        ENTITY_NAMES.OVERVIEW_AGENCY_SPEECH_RATIO,
        ENDPOINTS.VF_DASHBOARD_URL
    ),
    [REQUEST_TYPES.GET_OVERVIEW_AGENT_SPEECH_RATIO]: defaultChartRequest(
        url,
        ENTITY_NAMES.OVERVIEW_AGENT_SPEECH_RATIO,
        ENDPOINTS.VF_DASHBOARD_URL
    ),
    [REQUEST_TYPES.GET_AGENCY_SPEECH_RATIO]: defaultTableRequest(
        url,
        ENTITY_NAMES.AGENCIES_SPEECH_RATIO,
        ENDPOINTS.VF_DASHBOARD_URL
    ),
    [REQUEST_TYPES.GET_AGENCY_AGENTS_SPEECH_RATIO]: defaultTableRequest(
        url,
        ENTITY_NAMES.AGENCY_AGENTS_SPEECH_RATIO,
        ENDPOINTS.VF_DASHBOARD_URL
    ),
    [REQUEST_TYPES.GET_LOCATION_SPEECH_RATIO]: defaultTableRequest(
        url,
        ENTITY_NAMES.LOCATIONS_SPEECH_RATIO,
        ENDPOINTS.VF_DASHBOARD_URL
    ),
    [REQUEST_TYPES.GET_AGENCY_LOCATIONS_SPEECH_RATIO]: defaultTableRequest(
        url,
        ENTITY_NAMES.AGENCY_LOCATIONS_SPEECH_RATIO,
        ENDPOINTS.VF_DASHBOARD_URL
    ),
    [REQUEST_TYPES.GET_LOCATION_AGENTS_SPEECH_RATIO]: defaultTableRequest(
        url,
        ENTITY_NAMES.LOCATIONS_AGENTS_SPEECH_RATIO,
        ENDPOINTS.VF_DASHBOARD_URL
    ),
    [REQUEST_TYPES.GET_LOCATION_TEAMS_SPEECH_RATIO]: defaultTableRequest(
        url,
        ENTITY_NAMES.LOCATIONS_TEAMS_SPEECH_RATIO,
        ENDPOINTS.VF_DASHBOARD_URL
    )
};
